var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 3.75H16.6875V2.8125C16.6875 1.26169 15.4258 0 13.875 0H10.125C8.57419 0 7.3125 1.26169 7.3125 2.8125V3.75H2.625C2.10722 3.75 1.6875 4.16972 1.6875 4.6875C1.6875 5.20528 2.10722 5.625 2.625 5.625C3.14194 5.625 3.5625 6.04556 3.5625 6.5625V21.1875C3.5625 22.7383 4.82419 24 6.375 24H17.625C19.1758 24 20.4375 22.7383 20.4375 21.1875V6.5625C20.4375 6.04556 20.8581 5.625 21.375 5.625C21.8928 5.625 22.3125 5.20528 22.3125 4.6875C22.3125 4.16972 21.8928 3.75 21.375 3.75ZM9.1875 2.8125C9.1875 2.29556 9.60806 1.875 10.125 1.875H13.875C14.3919 1.875 14.8125 2.29556 14.8125 2.8125V3.75H9.1875V2.8125ZM18.5625 6.5625V21.1875C18.5625 21.7044 18.1419 22.125 17.625 22.125H6.375C5.85806 22.125 5.4375 21.7044 5.4375 21.1875V6.5625C5.4375 6.23386 5.38031 5.91844 5.27625 5.625H18.7238C18.6197 5.91844 18.5625 6.23386 18.5625 6.5625Z",
    fill: "#0E60B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7.5C7.73222 7.5 7.3125 7.91972 7.3125 8.4375V19.3125C7.3125 19.8303 7.73222 20.25 8.25 20.25C8.76778 20.25 9.1875 19.8303 9.1875 19.3125V8.4375C9.1875 7.91972 8.76778 7.5 8.25 7.5Z",
    fill: "#0E60B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C11.4822 7.5 11.0625 7.91972 11.0625 8.4375V19.3125C11.0625 19.8303 11.4822 20.25 12 20.25C12.5178 20.25 12.9375 19.8303 12.9375 19.3125V8.4375C12.9375 7.91972 12.5178 7.5 12 7.5Z",
    fill: "#0E60B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 8.4375V19.3125C14.8125 19.8303 15.2322 20.25 15.75 20.25C16.2678 20.25 16.6875 19.8303 16.6875 19.3125V8.4375C16.6875 7.91972 16.2678 7.5 15.75 7.5C15.2322 7.5 14.8125 7.91972 14.8125 8.4375Z",
    fill: "#0E60B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.d7ff3b4a509a70c62e0a25e3d2e550e3.svg";
export { ForwardRef as ReactComponent };